import React, { ErrorInfo, ReactNode } from "react";

type ErrorBoundaryProps = {
  children?: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(error: any): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    // Log the error or send it to an external error reporting service
    console.error("REVISAR:", error);
  }

  render() {
    /**UI en caso de falla general. */
    if (this.state.hasError) return <></>;
    /**UI en caso normal (sin falla). */
    return this.props.children;
  }
}
